var _rect, _rect2, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcAsync(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    rx: 6,
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_18023_5483",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 12,
    width: 32,
    height: 32
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 12,
    width: 32,
    height: 32,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_18023_5483)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.3327 27.4641V22.6641C29.3327 22.2863 29.2049 21.9696 28.9494 21.7141C28.6938 21.4585 28.3771 21.3307 27.9994 21.3307C27.6216 21.3307 27.3049 21.4585 27.0494 21.7141C26.7938 21.9696 26.666 22.2863 26.666 22.6641V27.9641C26.666 28.1418 26.6994 28.3141 26.766 28.4807C26.8327 28.6474 26.9327 28.7974 27.066 28.9307L31.466 33.3307C31.7105 33.5752 32.0216 33.6974 32.3994 33.6974C32.7771 33.6974 33.0882 33.5752 33.3327 33.3307C33.5771 33.0863 33.6994 32.7752 33.6994 32.3974C33.6994 32.0196 33.5771 31.7085 33.3327 31.4641L29.3327 27.4641ZM27.9994 41.3307C26.1549 41.3307 24.4216 40.9807 22.7994 40.2807C21.1771 39.5807 19.766 38.6307 18.566 37.4307C17.366 36.2307 16.416 34.8196 15.716 33.1974C15.016 31.5752 14.666 29.8418 14.666 27.9974C14.666 26.153 15.016 24.4196 15.716 22.7974C16.416 21.1752 17.366 19.7641 18.566 18.5641C19.766 17.3641 21.1771 16.4141 22.7994 15.7141C24.4216 15.0141 26.1549 14.6641 27.9994 14.6641C29.8438 14.6641 31.5771 15.0141 33.1994 15.7141C34.8216 16.4141 36.2327 17.3641 37.4327 18.5641C38.6327 19.7641 39.5827 21.1752 40.2827 22.7974C40.9827 24.4196 41.3327 26.153 41.3327 27.9974C41.3327 29.8418 40.9827 31.5752 40.2827 33.1974C39.5827 34.8196 38.6327 36.2307 37.4327 37.4307C36.2327 38.6307 34.8216 39.5807 33.1994 40.2807C31.5771 40.9807 29.8438 41.3307 27.9994 41.3307ZM27.9994 38.6641C30.9549 38.6641 33.4716 37.6252 35.5494 35.5474C37.6271 33.4696 38.666 30.953 38.666 27.9974C38.666 25.0418 37.6271 22.5252 35.5494 20.4474C33.4716 18.3696 30.9549 17.3307 27.9994 17.3307C25.0438 17.3307 22.5271 18.3696 20.4494 20.4474C18.3716 22.5252 17.3327 25.0418 17.3327 27.9974C17.3327 30.953 18.3716 33.4696 20.4494 35.5474C22.5271 37.6252 25.0438 38.6641 27.9994 38.6641Z",
    fill: "#612EF7"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcAsync);
export default __webpack_public_path__ + "static/media/ic_async.0c256d4d79ecf951368651be9ba13de2.svg";
export { ForwardRef as ReactComponent };